import styled from 'styled-components';
import { tokens } from '@mindtickle/styles/lib';

export const StyledLearningWrapper = styled.div`
  display: flex;
  padding: 8px 8px 0 0;
  row-gap: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .dropdown-action-item-wrapper {
    padding: 0 0 0 8px;
  }

  .advance-link {
    display: flex;
    flex: 1;

    &-btn {
      flex: 1;
    }
  }

  .learning-site-divider {
    height: 20px;
    margin: 0 4px;
  }

  &&& .learning-site-copy-btn {
    border: none;

    .btn-icon {
      font-size: 16px;
    }

    &:hover {
      background-color: ${tokens.bgTokens.COLOR_BG_ACCENT};
      border: none;
      .btn-icon {
        color: ${tokens.iconTokens.COLOR_ICON_INVERSE_TERTIARY};
      }
    }
  }
`;

export const StyledDropdownActionItemWrapper = styled.div`
  padding: 4px 8px;
  flex: 1;

  &.styled-content {
    padding: 0px 8px 4px;
  }

  .dropdown-action-label {
    cursor: pointer;
    padding: 6px 16px;
    border-radius: 4px;
    transition: background-color 0.3s ease;
  }
  &:hover {
    .dropdown-action-label {
      color: ${tokens.textTokens.COLOR_TEXT_INVERSE};
      background-color: ${tokens.bgTokens.COLOR_BG_ACCENT};
    }
  }
`;
